export const config= {
    host:"/api"
}
